import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Row } from "react-flexbox-grid";
import NumericInput from "react-numeric-input";
import ReactLoading from "react-loading";

import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import DatePicker from "material-ui-pickers/DatePicker";
import TextField from "@material-ui/core/TextField";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import httpr from "lib/httpRequest";
import { BASE_URL } from "lib/config";
import { FormHelperText, Tooltip } from "@material-ui/core";
const moment = require("moment");

const styles = (theme) => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  formControl: {
    margin: theme.spacing.unit,
    width: "99%",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  dates: {
    display: "inline",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const kisanReports = ["Grand_Totals", "Usage_Totals", "Terminal_Summary", "User_Summary", "Transaction_Log", "Detail_Report"];

class ReportOptions extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      selectedLocIds: [],
      selectedReportType: "",
      selectedSecondOption: ["All"],
      secondRowOptItems: [],
      sites: [],
      selectedSites: ["All"],
      showSitesDropdown: false,
      showFunctionLevel: false,
      selectedFunctionLevel: 0,
      showUserLevel: false,
      selectedUserLevel: 0,
      showChooseDelete: false,
      selectedDeleteChoice: 0,
      showOpenTillDelay: false,
      selectedOpenTillDelay: 10,
      startDate: new Date().toLocaleString(),
      endDate: new Date().toLocaleString(),
      DaysToNotify: [],
      MinusDays: 1, //Days to inlcude
      showMinusDays: true,
      StartHour: "07:30",
      showDatePickers: true,
      showStartDateOnly: false,
      allDaysSelected: true,
      selectedDaysToNotify: ["All"],
      userSummaryCheck: 0,
      allDay: 0,
      sendXlsx: 0,
      sendPdf: 0,
      signedInMemberReports: [],
      secondOptDropdownDisabled: false
    };

    if (this.props.edit) {
      const deleteChoice = this.props.editData.showDelete.includes("No")
        ? 0
        : 1;
      const userSum = this.props.editData.userSummaryCheck.includes("No")
        ? 0
        : 1;
      let momentHr = moment(this.props.editData.StartHour, "HH:mm A");
      const startHour = momentHr.format("HH:mm");
      const functionLevel = this.props.editData.functionLevel.includes("All")
        ? 0
        : this.props.editData.functionLevel.includes("Machine")
          ? 1
          : 2;
      const userLevel = this.props.editData.userLevel.includes("All")
        ? 0
        : this.props.editData.userLevel.includes("Cashier")
          ? 1
          : 2;

      //deal with location name
      let locs = [];
      this.props.Locations.map((location) => {
        if (
          location.LocationName ===
          this.props.editData.LocationName.replace(/ /g, "_")
        ) {
          locs.push(location.LocationId);
        }
      });
      const locationIds = locs;

      let dayIndexes = [];
      let allDaysSelected = true;
      if (this.props.editData.DaysToNotify.includes("All")) {
        dayIndexes = ["All"];
      } else {
        this.props.editData.DaysToNotify.split(", ").map((day) => {
          dayIndexes.push(days.indexOf(day));
          allDaysSelected = false;
        });
        if (dayIndexes.length === days.length) {
          dayIndexes = ["All"];
        }
      }

      this.state = {
        ...this.state,
        StartHour: startHour,
        MinusDays: this.props.editData.MinusDays,
        selectedReportType: this.props.editData.report.replace(/\s/g, "_"),
        selectedDaysToNotify: dayIndexes,
        selectedOpenTillDelay: this.props.editData.openTillDelay,
        selectedDeleteChoice: deleteChoice,
        userSummaryCheck: userSum,
        selectedFunctionLevel: functionLevel,
        selectedUserLevel: userLevel,
        selectedLocIds: locationIds,
        allDaysSelected: allDaysSelected,
      };
    }
  }

  componentDidMount() {
    this._isMounted = true;
    this.getMemberReports();
    if (this.props.edit) {
      // call handleChanged to set all correct states according to selected report set in constructor
      let fooEvent = { target: { name: "first" } };
      this.handleChanged(fooEvent);
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  getTerminals(locationIds) {
    // fetch terminals for selected locations
    const { token } = this.props;
    const fetch = httpr(token);
    fetch
      .post("/api/terminal/locations/", { 
        locationIds: locationIds,
      })
      .then((response) => {
        const { terminals } = response.data;

        // only show site dropdown if more than one site mentioned in terminal object array
        // if there's more than one site, set Terminals according to 
        if (terminals.length > 0){
          let siteCount = 1;
          let siteId = terminals[0].SITE_ID;
          terminals.map(terminal => {
            if (terminal.SITE_ID == siteId) {
              //do nothing, still only one site mentioned
              // this.setState({ showSitesDropdown: true });
            } else {
              siteCount++;
              this.setState({ showSitesDropdown: true });
            }
          })
        }

        if (this.props.edit === true) {
          // set correct selected terminal as well as populating dropdown
          let temp = ["All"];
          if (this.props.editData.terminalId !== -1) {
            terminals.map((terminalObj, index) => {
              if (terminalObj.TERMINAL_ID == this.props.editData.terminalId) {
                //save the index of this terminal
                temp = [];
                temp.push(index);
              }
            });
          };
          if (this._isMounted === true) {
            this.setState({
              secondRowOptItems: terminals,
              selectedSecondOption: temp,
            });
          };
        } else {
          if (this._isMounted === true) {
            // set state
            this.setState({
              secondRowOptItems: terminals,
              selectedSecondOption: ["All"],
            });
          };
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getVaults(locationIds) {
    // fetch terminals for selected locations
    const { token } = this.props;
    const fetch = httpr(token);
    fetch
      .post("/api/vault/locations/", {
        locationIds: locationIds,
      })
      .then((response) => {
        const { vaults } = response.data;

        if (this.props.edit === true) {
          // set correct selected vault as well as populating dropdown
          let temp = ["All"];
          if (this.props.editData.vaultId !== -1) {
            vaults.map((vaultObj, index) => {
              if (vaultObj.VAULT_ID == this.props.editData.vaultId) {
                //save the index of this terminal
                temp = [];
                temp.push(index);
              }
            });
          }
          if (this._isMounted === true) {
            this.setState({
              secondRowOptItems: vaults,
              selectedSecondOption: temp,
            });
          }
        } else {
          if (this._isMounted === true) {
            // set state
            this.setState({
              secondRowOptItems: vaults,
              selectedSecondOption: ["All"],
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getMemberReports() {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    return new Promise(async (resolve, reject) => {
      fetch
        .get(`${BASE_URL}/api/members/reports/${this.props.member.MemberId}`)
        .then((response) => {
          if (this._isMounted == true) {
            // sort alphabetically
            let sortedReports = response.data.sort(
              (a, b) => (a.ReportName > b.ReportName ? 1 : -1)
            );
            this.setState({ signedInMemberReports: sortedReports });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  getSites = (locationIds) => {

    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    // Fetch data from api
    fetch
      .post("/api/site/locations/", {
        locationIds: locationIds,
      })// /api/site/:locationId  ${this.props.dataUrl}
      .then((response) => {
        const { sites } = response.data;
        // get index of site with corresponding SITE_ID from passed prop

        if (this.props.edit === true) {
          // set correct selected sites value as well as populating dropdown
          let temp = ["All"];
          if(this.props.editData.siteId !== -1) {
            sites.map((site, index) => {
              if (site.SITE_ID == this.props.editData.siteId) {
                //save the index of the site
                temp = [];
                temp.push(index);
              }
            });
          }
          if (this._isMounted === true) {
            this.setState({
              sites: sites,
              selectedSites: temp, //selected MUST be a number for dropdown to function properly
            });
          }
        } else {
          if (this._isMounted === true) {
            this.setState({
              sites: sites,
              selectedSites: ["All"], 
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChanged = (event) => {
    if (event.target.name === "selectedLocIds") {
      // update the state
      this.setState({ selectedLocIds: event.target.value });
      // if report is selected and needs terminals, fetch terminals
      if (
        event.target.value.length > 0 &&
        this.state.selectedReportType.length > 0
      ) {
        if (
          this.state.selectedReportType === "Grand_Totals" ||
          this.state.selectedReportType === "Usage_Totals" ||
          this.state.selectedReportType === "End_Of_Day_Totals" ||
          this.state.selectedReportType === "Transaction_Log" ||
          this.state.selectedReportType === "Detail_Report" ||
          this.state.selectedReportType === "Forced_Notes" ||
          this.state.selectedReportType === "Terminal_Summary" ||
          this.state.selectedReportType === "Error_Log" || this.state.selectedReportType === "User_Summary"
        ) {
          this.getSites(event.target.value);
          this.getTerminals(event.target.value);
        }
      }
    } else if (
      event.target.name === "selectedReportType" ||
      (this.props.edit === true && event.target.name === "first")
    ) {
      if (event.target.name !== "first") {
        // set report
        this.setState({
          selectedReportType: event.target.value,
        });
      }

      const reportName =
        event.target.name === "selectedReportType"
          ? event.target.value
          : this.state.selectedReportType;

      // if report needs terminals, fetch terminals
      if (
        reportName === "Grand_Totals" ||
        reportName === "Usage_Totals" ||
        reportName === "End_Of_Day_Totals" ||
        reportName === "Transaction_Log" ||
        reportName === "Detail_Report" ||
        reportName === "Forced_Notes" ||
        reportName === "Terminal_Summary" ||
        reportName === "Error_Log" ||
        reportName === "User_Summary"
      ) { 
        this.getSites(this.state.selectedLocIds);
        this.getTerminals(this.state.selectedLocIds);
        
      }

      // if report needs vaults, fetch vaults
      if (
        reportName === "Vault_Grand_Totals" ||
        reportName === "Vault_Transaction_Log"
      ){
        this.getVaults(this.state.selectedLocIds);
      }

      // set state for all other options according to report type
      if (
        reportName === "Grand_Totals" ||
        reportName === "Vault_Grand_Totals" ||
        reportName === "Vault_Summary"
        ) {
        this.setState({
          showDatePickers: false,
          showMinusDays: false,
          showStartDateOnly: false,
          showFunctionLevel: false,
          showUserLevel: false,
          showChooseDelete: false,
          showUserSummaryCheck: false,
        });
      } else if (
        reportName === "End_Of_Day_Totals" //|| reportName === BALANCE_REPORT
      ) {
        this.setState({
          showDatePickers: true,
          showStartDateOnly: false,
          showMinusDays: true,
          showFunctionLevel: false,
          showUserLevel: false,
          showChooseDelete: false,
          showUserSummaryCheck: false,
        });
      } else if (
        reportName === "Transaction_Log" 
      ) {
        this.setState({
          showFunctionLevel: true,
          showDatePickers: true,
          showStartDateOnly: false,
          showUserLevel: false,
          showChooseDelete: false,
          showUserSummaryCheck: false,
          showMinusDays: true,
        });
      } else if (
        reportName === "Vault_Transaction_Log"
      ) {
        this.setState({
          showDatePickers: true,
          showStartDateOnly: false,
          showUserLevel: false,
          showChooseDelete: false,
          showUserSummaryCheck: false,
          showMinusDays: true,
        });
      } else if (
        reportName === "Till_Profile" ||
        reportName === "Register_Profile"
      ) {
        // Disable start and end date options
        this.setState({
          showDatePickers: false,
          showMinusDays: false,
          showStartDateOnly: false,
          showFunctionLevel: false,
          showUserLevel: false,
          showChooseDelete: false,
          showUserSummaryCheck: false,
        });
      } else if (reportName === "User_Profile") {
        this.setState({
          showUserLevel: true,
          showChooseDelete: true,
          showDatePickers: false,
          showMinusDays: false,
          showStartDateOnly: false,
          showFunctionLevel: false,
          showUserSummaryCheck: false,
        });
      } else if (reportName === "Open_Till") {
        this.setState({
          showDatePickers: true,
          showStartDateOnly: false,
          showFunctionLevel: false,
          showUserLevel: false,
          showChooseDelete: false,
          showUserSummaryCheck: false,
          showMinusDays: true,
        });
      } else if (reportName === "User_Summary") {
        // Show 24/7 checkmark
        this.setState({
          showUserSummaryCheck: true,
          showDatePickers: true,
          showStartDateOnly: false,
          showFunctionLevel: false,
          showUserLevel: false,
          showChooseDelete: false,
          showMinusDays: true,
        });
      } else {
        this.setState({
          showDatePickers: true,
          showStartDateOnly: false,
          showFunctionLevel: false,
          showUserLevel: false,
          showChooseDelete: false,
          showUserSummaryCheck: false,
          showMinusDays: true,
        });
      }
    } else if (event.target.name === "selectedSecondOption") {
      let useAllIndex = event.target.value.indexOf("All");
      // if last in array, all triggered event
      if (useAllIndex === event.target.value.length - 1) {
        event.target.value = ["All"];
      } else {
        let nValues = [];

        event.target.value.forEach((v) => {
          if (v !== "All") {
            nValues.push(v);
          }
        });
        event.target.value = nValues;
      }

      // if in edit card, multiples are not allowed
      if (this.props.edit) {
        // take the last index and save that one
        let newValue = [-22];
        event.target.value.map((termIndex, index) => {
          if (index === event.target.value.length - 1) {
            newValue = [];
            newValue.push(termIndex);
          }
        });
        this.setState({ [event.target.name]: newValue });
      } else {
        this.setState({
          [event.target.name]: event.target.value,
        });
      }
    } else if (event.target.name === "selectedFunctionLevel") {
      this.setState({
        [event.target.name]: event.target.value,
      });
    } else if (event.target.name === "selectedUserLevel") {
      this.setState({
        [event.target.name]: event.target.value,
      });
    } else if (event.target.name === "selectedDeleteChoice") {
      this.setState({
        [event.target.name]: event.target.value,
      });
    } else if (event.target.name === "selectedOpenTillDelay") {
      this.setState({
        [event.target.name]: event.target.value,
      });
    } else if (event.target.name === "selectedSites") {
      // set selected sites
      let tempSelectedSites = [];
      let useAllIndex = event.target.value.indexOf("All");
      let disableSecondOptDropdown = false;
      if (useAllIndex === event.target.value.length - 1 || event.target.value.length < 1) {
        //All sites
        tempSelectedSites = ["All"];
      } else {
        //Specific sites
        let nValues = [];
        event.target.value.forEach((v) => {
          if (v !== "All") {
            nValues.push(v);
          }
        });
        tempSelectedSites = nValues;
      }
      // Terminals available at selected sites?
      let termsAtSelectedSites = [];
      if (useAllIndex !== event.target.value.length - 1 || event.target.value.length > 1) {
        this.state.secondRowOptItems.map((term, i) => {
          tempSelectedSites.map(index => {
            if( typeof index === "number"){
              if (term.SITE_ID == this.state.sites[index].SITE_ID) {
                termsAtSelectedSites.push(i);
              }
            }
          });
        });
      }

      // disable terminal dropdown if none available at selected sites
      if(termsAtSelectedSites.length < 1 && !(tempSelectedSites.length == 1 && tempSelectedSites[0] == "All")) { 
        disableSecondOptDropdown = true;
      } 

      //set selected sites and terminals
      this.setState({ [event.target.name]: tempSelectedSites, secondOptDropdownDisabled: disableSecondOptDropdown,
        selectedSecondOption: ["All"] });
    }
  };

  handleStartDateChange = (date) => {
    if (date.valueOf() > this.state.endDate.valueOf()) {
      this.setState({ startDate: date, StartHour: date, endDate: date });
    } else {
      this.setState({ startDate: date, StartHour: date });
    }
  };

  handleEndDateChange = (date) => {
    if (this.state.startDate.valueOf() < date.valueOf()){
      this.setState({ endDate: date });
    } else {
      this.setState({ endDate: this.state.startDate });
    }
  };

  handleOpenTillDelayChange = (OpenTillDelay) => {
    this.setState({ selectedOpenTillDelay: OpenTillDelay });
  };

  handleUserSummaryCheck = (event) => {
    let userSummaryCheck = this.state.userSummaryCheck === 1 ? 0 : 1;
    this.setState({ userSummaryCheck: userSummaryCheck });
  };

  handleAllDayToggle = (event) => {
    let allDay = this.state.allDay === 1 ? 0 : 1;
    this.setState({
      allDay: allDay,
    });
  };

  handleSendPdf = (event) => {
    let sendPdf = this.state.sendPdf === 1 ? 0 : 1;
    this.setState({
      sendPdf: sendPdf,
    });
  };

  handleSendXlsx = (event) => {
    let sendXlsx = this.state.sendXlsx === 1 ? 0 : 1;
    this.setState({
      sendXlsx: sendXlsx,
    });
  };

  handleStartTimeChange = (event) => {
    this.setState({ StartHour: event.target.value });
  };

  handleDaySelected = (event) => {
    // if all is included in event.target.value, remove it before saving
    if (event.target.value.includes("All")) {
      if (event.target.value.length < 2) {
        this.setState({ allDaysSelected: true, selectedDaysToNotify: ["All"] });
      } else {
        let index = event.target.value.indexOf("All");
        if (index === 0) {
          let selected = event.target.value;
          selected.splice(index, 1);
          this.setState({
            allDaysSelected: false,
            selectedDaysToNotify: selected,
          });
        } else {
          this.setState({
            allDaysSelected: true,
            selectedDaysToNotify: ["All"],
          });
        }
      }
    } else {
      if (event.target.value.length < 1) {
        this.setState({ allDaysSelected: true, selectedDaysToNotify: ["All"] });
      } else {
        this.setState({
          allDaysSelected: false,
          selectedDaysToNotify: event.target.value,
        });
      }
    }
  };

  renderSelectedLocationValues = (event) => {
    const { Locations } = this.props;
    const { selectedLocIds } = this.state;
    let locNames = [];

    Locations.map((loc) => {
      if (selectedLocIds.indexOf(loc.LocationId) > -1) {
        locNames.push(loc.LocationName.replace(/_/g, " "));
      }
    });

    return locNames.join(", ");
  };

  renderSelectedSecondOptValues = (event) => {
    let rVals = [];
    const { secondRowOptItems } = this.state;

    if(this.state.secondOptDropdownDisabled){
      rVals.push("N/A");
      return rVals.join(", ");
   }

    event.forEach((v) => {
      if (typeof v === "string") {
        rVals.push(v); //"All"
      } else if (typeof v === "number") {
        v = secondRowOptItems[v];

        if (v.location) {
          if (this.state.selectedReportType === "Vault_Grand_Totals" || this.state.selectedReportType === "Vault_Transaction_Log" || this.state.selectedReportType === "Vault_Summary"){
            rVals.push(
              `${v.location.LocationName.replace(/_/g, " ")} - ${v.VAULT_NAME}`
            );
          } else {
            rVals.push(
              `${v.location.LocationName.replace(/_/g, " ")} - ${v.TERMINAL_NAME}`
            );
          }

        } else if (v.USER_NAME) {
          rVals.push(v.USER_NAME);
        }
      }
    });

    return rVals.join(", ");
  };

  renderSelectedDayValues = (event) => {
    if (event.includes("All")) {
      return "All";
    }
    // if multiple
    if (event.length > 1) {
      let list = [];
      let day;
      event.map((i) => {
        day = days[i];
        list.push(day);
      });
      return list.join(", ");
    } else {
      // if only one
      if (days[event]) {
        const day = days[event];
        return day;
      }
    }
  };

  // This returns what's displayed in the selected label ONLY
  renderSelectedSiteValues = (event) => {
    const { sites } = this.state;

    if ((event.length)-1 == sites.length) {
      return "All";
    } else if (event.length > 1) {
      let list = [];
      let siteName;
      event.filter(i => typeof i === "number").map((i) => {
        siteName = sites[i].SITE_NAME;
        list.push(siteName);
      });
      return list.join(", ");
    }  else if (event.includes("All")) {
      return "All";
    } else { // only one picked
      if (sites[event]) {
        const site = [sites[event].SITE_NAME];
        return site;
      }
    }
  };

  /**
   * Called on "Generate" click.
   * API call is in parent component: Reports.jsx
   */
  reportOptionButton = exportOption => () => {
    const { member } = this.props;
    const {
      secondRowOptItems,
      selectedSecondOption,
      selectedLocIds,
      selectedReportType,
      selectedFunctionLevel,
      selectedUserLevel,
      selectedDeleteChoice,
      selectedOpenTillDelay,
      selectedDaysToNotify,
      userSummaryCheck,
      startDate,
      endDate,
      StartHour,
      secondOptDropdownDisabled
    } = this.state;
    const { Locations } = member;

    const report = selectedReportType.replace(/\s/g, "_");

    let optionsList = [];

    // Handle user level
    let userLevel = selectedUserLevel - 1;
    Locations.map(async (location) => {
      const selectedLocIndex = selectedLocIds.indexOf(location.LocationId);

      if (selectedLocIndex >= 0) {
        let terminalId = -1;
        let userId = -1;
        let vaultId = -1;

        // if specific terminals were specified
        if (!selectedSecondOption.includes("All")) {
          // check for Kisan at location
          if ((kisanReports.includes(selectedReportType)) && location.HasKisanMachine === 1) {

            let selectedTerminals = [];
            
            selectedSecondOption.map((indexOfSecondRowOptItems) => {
              selectedTerminals.push(secondRowOptItems[indexOfSecondRowOptItems]);
            });

            selectedTerminals.forEach((terminalObj) => {
              // only want to create a new object for this terminal if this terminal is at the location
              // need to match the terminal to the location
              if (
                terminalObj.location.LocationId === location.LocationId
              ) {
                let v = terminalObj;
                if (v.TERMINAL_ID) {
                  terminalId = v.TERMINAL_ID;
                } else if (v.USER_ID) {
                  userId = v.USER_ID;
                } else if (v.VAULT_ID) {
                  vaultId = v.VAULT_ID;
                }
  
                // get list of days
                let dayList = [];
                if (!this.state.allDaysSelected) {
                  this.state.selectedDaysToNotify.map((i) => {
                    dayList.push(days[i]);
                  });
                  dayList = dayList.join();
                } else {
                  dayList = ["All"];
                }
  
                const options = {
                  exportOption: exportOption,
                  ID: member.MemberId,
                  Type: "",
                  MemberId: member.MemberId,
                  RECYCLER_LOG_ERROR_ID: null,
                  RECYCLER_ID: null,
                  report: report,
                  LocationId: location.LocationId,
                  LocationName: location.LocationName,
                  OrganizationId: location.OrganizationId,
                  terminalId: terminalId,
                  terminalName: terminalObj.TERMINAL_NAME,
                  vaultId: vaultId,
                  startBusDate: startDate,
                  endBusDate: endDate,
                  userId: parseInt(userId),
                  registerId: -1,
                  loaded: false,
                  grandTotal: 0,
                  registers: [],
                  reportName: selectedReportType,
                  MinusDays: parseInt(this.state.MinusDays, 10),
                  StartHour: StartHour, //.toLocaleTimeString("en-US", {
                  //   hour12: false
                  // }),
                  DaysToNotify: dayList,
                  functionLevel: selectedFunctionLevel,
                  userLevel: userLevel,
                  showDelete: selectedDeleteChoice,
                  openTillDelay: selectedOpenTillDelay,
                  userSummaryCheck: userSummaryCheck,
                  termsAvailableAtSite: !secondOptDropdownDisabled,
                  location: {
                    LocationId: location.LocationId,
                    LocationName: location.LocationName,
                    OrganizationId: location.OrganizationId,
                    TimeZoneName: "PST",
                    MemberId: member.MemberId,
                  },
                };
                optionsList.push(options);
              }
            });
          } else {
            // specific terminals specified
            // No kisan machines at location
            // loop through each selected terminal and create an object for each
            selectedSecondOption.forEach((so) => {
              // only want to create a new object for this terminal if this terminal is at the location
              // need to match the terminal to the location
              if (
                secondRowOptItems[so].location.LocationId === location.LocationId
              ) {
                let v = secondRowOptItems[so];
                if (v.TERMINAL_ID) {
                  terminalId = v.TERMINAL_ID;
                } else if (v.USER_ID) {
                  userId = v.USER_ID;
                } else if (v.VAULT_ID) {
                  vaultId = v.VAULT_ID;
                }

                // get list of days
                let dayList = [];
                if (!this.state.allDaysSelected) {
                  this.state.selectedDaysToNotify.map((i) => {
                    dayList.push(days[i]);
                  });
                  dayList = dayList.join();
                } else {
                  dayList = ["All"];
                }

                const options = {
                  exportOption: exportOption,
                  ID: member.MemberId,
                  Type: "",
                  MemberId: member.MemberId,
                  RECYCLER_LOG_ERROR_ID: null,
                  RECYCLER_ID: null,
                  report: report,
                  LocationId: location.LocationId,
                  LocationName: location.LocationName,
                  OrganizationId: location.OrganizationId,
                  terminalId: terminalId,
                  vaultId: vaultId,
                  startBusDate: startDate,
                  endBusDate: endDate,
                  userId: parseInt(userId),
                  registerId: -1,
                  loaded: false,
                  grandTotal: 0,
                  registers: [],
                  reportName: selectedReportType,
                  MinusDays: parseInt(this.state.MinusDays, 10),
                  StartHour: StartHour, //.toLocaleTimeString("en-US", {
                  //   hour12: false
                  // }),
                  DaysToNotify: dayList,
                  functionLevel: selectedFunctionLevel,
                  userLevel: userLevel,
                  showDelete: selectedDeleteChoice,
                  openTillDelay: selectedOpenTillDelay,
                  userSummaryCheck: userSummaryCheck,
                  termsAvailableAtSite: !secondOptDropdownDisabled,
                  location: {
                    LocationId: location.LocationId,
                    LocationName: location.LocationName,
                    OrganizationId: location.OrganizationId,
                    TimeZoneName: "PST",
                    MemberId: member.MemberId,
                  },
                };
                optionsList.push(options);
              }
            });
          }
        } else {
          // All terms selected
          // check for Kisan at location
          if ((kisanReports.includes(selectedReportType)) && location.HasKisanMachine === 1) {
            let selectedTerminals = [];
            // push all available terminals to array
            secondRowOptItems.map(term => {
              selectedTerminals.push(term);
            });
            selectedTerminals.forEach((terminalObj) => {
              // only want to create a new object for this terminal if this terminal is at the location
              // need to match the terminal to the location

              if (
                terminalObj.location.LocationId === location.LocationId
              ) {
                let v = terminalObj;
                if (v.TERMINAL_ID) {
                  terminalId = v.TERMINAL_ID;
                } else if (v.USER_ID) {
                  userId = v.USER_ID;
                } else if (v.VAULT_ID) {
                  vaultId = v.VAULT_ID;
                }
  
                // get list of days
                let dayList = [];
                if (!this.state.allDaysSelected) {
                  this.state.selectedDaysToNotify.map((i) => {
                    dayList.push(days[i]);
                  });
                  dayList = dayList.join();
                } else {
                  dayList = ["All"];
                }
  
                const options = {
                  exportOption: exportOption,
                  ID: member.MemberId,
                  Type: "",
                  MemberId: member.MemberId,
                  RECYCLER_LOG_ERROR_ID: null,
                  RECYCLER_ID: null,
                  report: report,
                  LocationId: location.LocationId,
                  LocationName: location.LocationName,
                  OrganizationId: location.OrganizationId,
                  terminalId: terminalId,
                  terminalName: terminalObj.TERMINAL_NAME,
                  vaultId: vaultId,
                  startBusDate: startDate,
                  endBusDate: endDate,
                  userId: parseInt(userId),
                  registerId: -1,
                  loaded: false,
                  grandTotal: 0,
                  registers: [],
                  reportName: selectedReportType,
                  MinusDays: parseInt(this.state.MinusDays, 10),
                  StartHour: StartHour, //.toLocaleTimeString("en-US", {
                  //   hour12: false
                  // }),
                  DaysToNotify: dayList,
                  functionLevel: selectedFunctionLevel,
                  userLevel: userLevel,
                  showDelete: selectedDeleteChoice,
                  openTillDelay: selectedOpenTillDelay,
                  userSummaryCheck: userSummaryCheck,
                  termsAvailableAtSite: !secondOptDropdownDisabled,
                  location: {
                    LocationId: location.LocationId,
                    LocationName: location.LocationName,
                    OrganizationId: location.OrganizationId,
                    TimeZoneName: "PST",
                    MemberId: member.MemberId,
                  },
                };
                optionsList.push(options);
              }
            });
          } else {
          // Second row options equals All, no need for extra objects
          // get list of days
          let dayList = [];
          if (!this.state.allDaysSelected) {
            this.state.selectedDaysToNotify.map((i) => {
              dayList.push(days[i]);
            });
            dayList = dayList.join();
          } else {
            dayList = ["All"];
          }

          const options = {
            exportOption: exportOption,
            ID: member.MemberId,
            Type: "",
            MemberId: member.MemberId,
            RECYCLER_LOG_ERROR_ID: null,
            RECYCLER_ID: null,
            report: report,
            LocationId: location.LocationId,
            LocationName: location.LocationName,
            OrganizationId: location.OrganizationId,
            terminalId: terminalId,
            vaultId: vaultId,
            startBusDate: startDate,
            endBusDate: endDate,
            userId: parseInt(userId),
            registerId: -1,
            loaded: false,
            grandTotal: 0,
            registers: [],
            reportName: selectedReportType,
            MinusDays: parseInt(this.state.MinusDays - 1, 10),
            StartHour: StartHour,
            DaysToNotify: dayList,
            functionLevel: selectedFunctionLevel,
            userLevel: userLevel,
            showDelete: selectedDeleteChoice,
            openTillDelay: selectedOpenTillDelay,
            userSummaryCheck: userSummaryCheck,
            termsAvailableAtSite: !secondOptDropdownDisabled,
            location: {
              LocationId: location.LocationId,
              LocationName: location.LocationName,
              OrganizationId: location.OrganizationId,
              TimeZoneName: "PST",
              MemberId: member.MemberId,
            },
          };
          optionsList.push(options);
          }
        }
      }
    });

    if (this.props.autoReport) {
      this.props.edit
        ? this.props.updateReportSettings(this.props.editData.ID, optionsList)
        : this.props.saveReportSettings(optionsList);
    } else {
      if (this.state.selectedReportType !== ""){
        this.props.generateReport(optionsList);
      }
      
    }
  };

  handleChangeMinusDay = (event, daysToInclude) => {
    let validatedDaysToInclude = daysToInclude
    if (daysToInclude < 0 || daysToInclude === '' || daysToInclude === null){
      validatedDaysToInclude = 1;
    } else if (daysToInclude > 90){
      validatedDaysToInclude = 90;
    }
    this.setState({
      MinusDays: validatedDaysToInclude,
    });
  };



  render() {
    const {
      classes,
      multiple,
      Locations,
      title,
      buttonTitle,
      autoReport,
    } = this.props;

    const {
      secondOptDropdownDisabled,
      selectedLocIds,
      selectedReportType,
      selectedSecondOption,
      showSitesDropdown,
      selectedSites,
      secondRowOptItems,
      showFunctionLevel,
      selectedFunctionLevel,
      showUserLevel,
      selectedUserLevel,
      showOpenTillDelay,
      selectedOpenTillDelay,
      showDatePickers,
      showStartDateOnly,
      showChooseDelete,
      selectedDeleteChoice,
      showUserSummaryCheck,
    } = this.state;

    // Handle locations dropdown
    let allLocations;
    if (multiple) {
      allLocations = Locations.map((loc) => {
        // Check if location license is expired
        // Note: null/missing license data is treated as valid (isValid: 1)
        const isExpired = loc.license && loc.license.isValid === 0;
        const isExpiringSoon = loc.license && 
                              loc.license.isValid === 1 && 
                              loc.license.daysUntilExpiration !== null &&
                              loc.license.daysUntilExpiration <= 30 &&
                              loc.license.daysUntilExpiration > 0;
        
        // Create location name with license status indicator
        let locationName = loc.LocationName.replace(/_/g, " ");
        if (isExpired) {
          locationName = `🔒 ${locationName} (Expired)`;
        } else if (isExpiringSoon) {
          locationName = `⚠️ ${locationName} (${loc.license.daysUntilExpiration} days)`;
        }
        
        return (
          <MenuItem 
            key={loc.LocationId} 
            value={loc.LocationId}
            disabled={isExpired}
            title={isExpired ? "License expired - Contact Socal Safe for renewal" : 
                   isExpiringSoon ? `License expires in ${loc.license.daysUntilExpiration} days - Contact Socal Safe for renewal` : 
                   null}
          >
            <Checkbox checked={selectedLocIds.indexOf(loc.LocationId) > -1} />
            <ListItemText primary={locationName} />
          </MenuItem>
        );
      });
    } else {
      // don't allow multiple in edit card
      allLocations = Locations.map((loc) => {
        // Check if location license is expired
        // Note: null/missing license data is treated as valid (isValid: 1)
        const isExpired = loc.license && loc.license.isValid === 0;
        const isExpiringSoon = loc.license && 
                              loc.license.isValid === 1 && 
                              loc.license.daysUntilExpiration !== null &&
                              loc.license.daysUntilExpiration <= 30 &&
                              loc.license.daysUntilExpiration > 0;
        
        // Create location name with license status indicator
        let locationName = loc.LocationName.replace(/_/g, " ");
        if (isExpired) {
          locationName = `🔒 ${locationName} (Expired)`;
        } else if (isExpiringSoon) {
          locationName = `⚠️ ${locationName} (${loc.license.daysUntilExpiration} days)`;
        }
        
        return (
          <MenuItem 
            key={loc.LocationId} 
            value={[loc.LocationId]}
            disabled={isExpired}
            title={isExpired ? "License expired - Contact Socal Safe for renewal" : 
                   isExpiringSoon ? `License expires in ${loc.license.daysUntilExpiration} days - Contact Socal Safe for renewal` : 
                   null}
          >
            {locationName}
          </MenuItem>
        );
      });
    }

    // Handle report dropdown
    let repType;
    if (this.props.member.Service === 0) {
      repType = this.state.signedInMemberReports
      .filter((type) => type.Reportname !== "Error_Log")
      .map((type) => (
        <MenuItem key={type.ReportName} value={type.ReportName}>
          {type.ReportName.replace(/_/g, " ")}
        </MenuItem>
      ));

      // Check Provisional Credit access
      let provCred = false;
      this.props.member.Locations.map((location) => {
        provCred = location["ProvisionalCredit"] == 1 ? true : false;
      })
      if (provCred === false) {
        repType = this.state.signedInMemberReports
        .filter((type) => {          
          return (type.ReportName != "Provisional_Credit");
        })
        .map((type) => (
          <MenuItem key={type.ReportName} value={type.ReportName}>
            {type.ReportName.replace(/_/g, " ")}
          </MenuItem>
        ));
      }

    } else {
      repType = this.state.signedInMemberReports.map((type) => (
        <MenuItem key={type.ReportName} value={type.ReportName}>
          {type.ReportName.replace(/_/g, " ")}
        </MenuItem>
      ));
    }

    // create "All" option
    let allOption;
    if (multiple) {
      allOption = (
        <MenuItem value="All" key="All">
          <Checkbox checked={selectedSecondOption.indexOf("All") >= 0} />
          <ListItemText primary="All" />
        </MenuItem>
      );
    } else {
      //want an all option but no checkbox
      allOption = (
        <MenuItem value="All" key="All">
          {"All"}
        </MenuItem>
      );
    }

    // Handle function level dropdown
    let functionLevelOpts = [];
    let functionLevelOptTitle = "Select Function Level";
    const functionLevelTip = "Choose Machine, User or All transaction types";
    if (selectedReportType === "Transaction_Log") {
      const functionLevelOptItems = ["All", "Machine", "User"];
      functionLevelOpts = functionLevelOptItems.map((level, index) => {
        return (
          <MenuItem key={index} value={index}>
            {level}
          </MenuItem>
        );
      });
    }

    // Handle user level dropdown
    let userLevelOpts = [];
    let userLevelOptTitle = "Select User Level";
    const userLevelTip = "Choose Manager, Cashier or All user types";
    if (selectedReportType === "User_Profile") {
      const userLevelOptItems = ["All", "Cashier", "Manager"];
      userLevelOpts = userLevelOptItems.map((level, index) => {
        return (
          <MenuItem key={index} value={index}>
            {level}
          </MenuItem>
        );
      });
    }
    // Handle show deleted users dropdown
    let showDeletedOpts = [];
    let showDeletedOptTitle = "Show Deleted Users?";
    const showDeletedTip =
      "Choose whether to show users that have been deleted";
    if (selectedReportType === "User_Profile") {
      const showDeletedOptItems = ["No", "Yes"]; // no is default
      showDeletedOpts = showDeletedOptItems.map((choice, index) => {
        return (
          <MenuItem key={index} value={index}>
            {choice}
          </MenuItem>
        );
      });
    }

    // Handle sites dropdown (which only shows if terminal list has more than one site mentioned)
    let siteOpt;
    if (showSitesDropdown == true) {
      siteOpt = this.state.sites.map((site, index) => {
        return (
          <MenuItem value={index} key={index}>
            <Checkbox
              checked={selectedSites.indexOf(index) >= 0}
            />
            <ListItemText
              primary={`${site.SITE_NAME}`}
            />
          </MenuItem>
        );
      });

      let allOpt;
      allOpt = (
        <MenuItem value="All" key="All">
          <Checkbox checked={selectedSites.indexOf("All") >= 0} />
          <ListItemText primary="All" />
        </MenuItem>
      );

      // Add "All" option to top of list
      siteOpt.unshift(allOpt);
    }


    // Handle second row options
    let secondRowOpt = [];
    let secondRowOptTitle = "Select";
    if (
      selectedReportType === "Grand_Totals" ||
      selectedReportType === "Usage_Totals" ||
      selectedReportType === "End_Of_Day_Totals" ||
      selectedReportType === "Transaction_Log" ||
      selectedReportType === "Detail_Report" ||
      selectedReportType === "Forced_Notes" ||
      selectedReportType === "Terminal_Summary" ||
      selectedReportType === "Error_Log" ||
      selectedReportType === "Vault_Grand_Totals" ||
      selectedReportType === "Vault_Transaction_Log"
    ) {
      secondRowOptTitle = selectedReportType === "Vault_Grand_Totals" || selectedReportType === "Vault_Transaction_Log" || selectedReportType === "Vault_Summary"
      ? "Select Vault" : "Select Terminal";
      if (secondRowOptItems) {
        // If there are option items and a location's been selected
        if (
          secondRowOptItems.length > 0 &&
          this.state.selectedLocIds.length > 0
        ) {
          // Get all terminal names for dropdown
          if (multiple) {
            secondRowOpt = secondRowOptItems.map((term, index) => {
              
              if (selectedReportType === "Vault_Grand_Totals" || selectedReportType === "Vault_Transaction_Log" || selectedReportType === "Vault_Summary") {
                return (
                  <MenuItem value={index} key={index}>
                    <Checkbox
                      checked={selectedSecondOption.indexOf(index) >= 0}
                    />
                    <ListItemText
                      primary={`${term.location.LocationName.replace(
                        /_/g,
                        " "
                      )} - ${term.VAULT_NAME}`}
                    />
                  </MenuItem>
                );
              }
              else if (((!kisanReports.includes(selectedReportType)) && term.TERMINAL_ID.toString().includes("K"))){
                // Deal with Kisan machines in dropdown 
                  return (false);  
              } else {      
                // Deal with all sites selected (site selection only optional if multiple sites in db for location)
                if (this.state.selectedSites == "All"){
                  // Show terminals from all sites
                  return (
                    <MenuItem value={index} key={index}>
                      <Checkbox
                        checked={selectedSecondOption.indexOf(index) >= 0}
                      />
                      <ListItemText
                        primary={`${term.location.LocationName.replace(
                          /_/g,
                          " "
                        )} - ${term.TERMINAL_NAME}`}
                      />
                    </MenuItem>
                  );
                } else {
                  // sites are specified, filter terminals
                  const temp = this.state.selectedSites.map((siteIndex) => {
                    if(term.SITE_ID == this.state.sites[siteIndex].SITE_ID){
                        return (
                          <MenuItem value={index} key={index}>
                            <Checkbox
                              checked={selectedSecondOption.indexOf(index) >= 0}
                            />
                            <ListItemText
                              primary={`${term.location.LocationName.replace(
                                /_/g,
                                " "
                              )} - ${term.TERMINAL_NAME}`}
                            />
                          </MenuItem>
                          );
                      }
                    });  
                    return temp;                  
                }
              }
            });
          } else {
            // don't allow multiple in edit card
            secondRowOpt = secondRowOptItems.map((term, index) => {
              if (selectedReportType === "Vault_Grand_Totals" || selectedReportType === "Vault_Transaction_Log" || selectedReportType === "Vault_Summary") {
                return (
                  <MenuItem value={index} key={index}>
                    {`${term.location.LocationName.replace(/_/g, " ")} - ${
                      term.VAULT_NAME
                    }`}
                  </MenuItem>
                );
              } else if (((!kisanReports.includes(selectedReportType)) && term.TERMINAL_ID.toString().includes("K"))){
                return (false);                
              } else {
                return (
                  <MenuItem value={index} key={index}>
                    {`${term.location.LocationName.replace(/_/g, " ")} - ${
                      term.TERMINAL_NAME
                    }`}
                  </MenuItem>
                );
              }

            });
          }
        }
      }
      secondRowOpt.unshift(allOption);
    }

    /*Select user dropdown*/
    // secondRowOptTitle = "Select User";
    // // Get all users for dropdown
    // secondRowOpt = secondRowOptItems.map((u, index) => (
    //   <MenuItem value={index} key={index}>
    //     <Checkbox checked={selectedSecondOption.indexOf(index) >= 0} />
    //     <ListItemText primary={u.USER_NAME} />
    //   </MenuItem>
    // ));
    // // Add "All" option to top of list
    // secondRowOpt.unshift(allOption);

    // handle date pickers
    let startDatePicker = (
      <DatePicker
        keyboard
        autoOk
        name="startDate"
        label="Start Date"
        disableFuture
        value={this.state.startDate}
        format="MM-dd-yyyy"
        onChange={this.handleStartDateChange}
        style={{
          width: "100%",
        }}
      />
    );
    let endDatePicker = (
      <DatePicker
        keyboard
        autoOk
        name="endDate"
        label="End Date"
        disableFuture
        value={this.state.endDate}
        format="MM-dd-yyyy"
        onChange={this.handleEndDateChange}
        style={{
          width: "100%",
        }}
      />
    );
    if (this.props.autoReport) {
      startDatePicker = <div />;
      endDatePicker = <div />;
    } else if (!showDatePickers) {
      startDatePicker = (
        <DatePicker
          keyboard
          autoOk
          disabled
          name="startDate"
          label="Start Date"
          disableFuture
          value={this.state.startDate}
          format="MM-dd-yyyy"
          onChange={this.handleStartDateChange}
          style={{
            width: "100%",
          }}
        />
      );
      endDatePicker = (
        <DatePicker
          keyboard
          autoOk
          disabled
          name="endDate"
          label="End Date"
          disableFuture
          value={this.state.endDate}
          format="MM-dd-yyyy"
          onChange={this.handleEndDateChange}
          style={{
            width: "100%",
          }}
        />
      );
    } else if (showStartDateOnly) {
      endDatePicker = (
        <DatePicker
          keyboard
          autoOk
          disabled
          name="endDate"
          label="End Date"
          disableFuture
          value={this.state.endDate}
          format="MM-dd-yyyy"
          onChange={this.handleEndDateChange}
          style={{
            width: "100%",
          }}
        />
      );
      if (selectedReportType === "Open_Till") {
        startDatePicker = (
          <DatePicker
            keyboard
            autoOk
            name="startDate"
            label="Business Date"
            disableFuture
            value={this.state.startDate}
            format="MM-dd-yyyy"
            helperText="Choose a completed business day"
            onChange={this.handleStartDateChange}
            style={{
              width: "100%",
            }}
          />
        );
      }
    }

    /* For Auto Reports */
    let dayMenu = days.map((day, index) => {
      return (
        <MenuItem key={index} value={index}>
          <Checkbox
            checked={this.state.selectedDaysToNotify.indexOf(index) > -1}
          />
          <ListItemText primary={day} />
        </MenuItem>
      );
    });

    // disable the days to include option for certain reports
    let daysToInclude;
    let daysToIncludeToolTip;
    if (!this.state.showMinusDays) {
      daysToIncludeToolTip =
        this.state.selectedReportType === "Grand_Totals" ||
        this.state.selectedReportType === "Vault_Grand_Totals" ||
        this.state.selectedReportType === "Vault_Summary"
          ? "This report shows totals in real time"
          : "This report only reports on one completed business day";
      daysToInclude = (
        <GridItem xs={12} sm={12} md={3}>
          <Row center="xs">
            <InputLabel>Days To Include</InputLabel>
          </Row>
          <NumericInput
            mobile
            disabled
            min={1}
            max={90}
            size={100}
            value={this.state.MinusDays}
            onChange={this.handleChangeMinusDay}
            style={{
              width: "100%",
              wrap: {
                marginBottom: "10px",
              },
              input: {
                display: "block",
                fontWeight: 100,
                width: "100%",
                height: "35px",
              },
            }}
          />
        </GridItem>
      );
    } else {
      daysToIncludeToolTip = "Choose how many business days to include.";
      daysToInclude = (
        <GridItem xs={12} sm={12} md={3}>
          <Row center="xs">
            <InputLabel>Days To Include</InputLabel>
          </Row>
          <NumericInput
            mobile
            min={1}
            max={90}
            size={100}
            value={this.state.MinusDays}
            onChange={this.handleChangeMinusDay}
            style={{
              width: "100%",
              wrap: {
                marginBottom: "10px",
              },
              input: {
                display: "block",
                fontWeight: 100,
                width: "100%",
                height: "35px",
              },
            }}
          />
        </GridItem>
      );
    }

    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="success">
                <h4 className={classes.cardTitleWhite}>{title}</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="select-multiple-checkbox">
                        Select Locations
                      </InputLabel>
                      <Select
                        name="selectedLocIds"
                        multiple={multiple}
                        value={this.state.selectedLocIds}
                        onChange={this.handleChanged}
                        input={<Input id="select-multiple-checkbox" />}
                        renderValue={this.renderSelectedLocationValues}
                        MenuProps={MenuProps}
                      >
                        {allLocations}
                      </Select>
                    </FormControl>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="select-reportType">
                        Select Report
                      </InputLabel>
                      <Select
                        name="selectedReportType"
                        value={this.state.selectedReportType}
                        onChange={this.handleChanged}
                        input={<Input id="select-reportType" />}
                        MenuProps={MenuProps}
                      >
                        {repType}
                      </Select>
                    </FormControl>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={3}>
                    <FormControl className={classes.formControl}>
                      <div className="picker">{startDatePicker}</div>
                    </FormControl>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={3}>
                    <FormControl className={classes.formControl}>
                      <div className="picker">{endDatePicker}</div>
                    </FormControl>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    
                    {(secondRowOptTitle === "Select Terminal" && this.state.showSitesDropdown)  && (
                      <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="select-sites">
                          Select Site
                        </InputLabel>
                        <Select
                          name="selectedSites"
                          multiple={true}
                          value={this.state.selectedSites}
                          input={<Input id="select-selectedSites" />}
                          renderValue={this.renderSelectedSiteValues}
                          MenuProps={MenuProps}
                          onChange={this.handleChanged}
                        >
                          {siteOpt}
                        </Select>
                      </FormControl>
                    )}
                    {secondRowOpt.length > 0 && (
                      <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="select-selectedSecondOption">
                          {secondRowOptTitle}
                        </InputLabel>
                        <Select
                          name="selectedSecondOption"
                          multiple={true}
                          disabled={secondOptDropdownDisabled}
                          value={selectedSecondOption}
                          input={<Input id="select-selectedSecondOption" />}
                          renderValue={this.renderSelectedSecondOptValues}
                          MenuProps={MenuProps}
                          onChange={this.handleChanged}
                        >
                          {secondRowOpt}
                        </Select>
                      </FormControl>
                    )}
                    {showUserLevel && (
                      <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="select-userLevel">
                          {userLevelOptTitle}
                        </InputLabel>
                        <Select
                          name="selectedUserLevel"
                          value={selectedUserLevel}
                          onChange={this.handleChanged}
                          input={<Input id="select-userLevel" />}
                          MenuProps={MenuProps}
                        >
                          {userLevelOpts}
                        </Select>
                        <FormHelperText>{userLevelTip}</FormHelperText>
                      </FormControl>
                    )}
                    {showUserSummaryCheck && (
                      <Tooltip
                        title="Best for clients who function 24/7"
                        placement="top-end"
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                this.state.userSummaryCheck === 1 ? true : false
                              }
                              onChange={this.handleUserSummaryCheck}
                            />
                          }
                          label="Include Overnight Shifts"
                        />
                      </Tooltip>
                    )}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    {showFunctionLevel && (
                      <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="select-functionLevel">
                          {functionLevelOptTitle}
                        </InputLabel>
                        <Select
                          name="selectedFunctionLevel"
                          value={selectedFunctionLevel}
                          onChange={this.handleChanged}
                          input={<Input id="select-functionLevel" />}
                          MenuProps={MenuProps}
                        >
                          {functionLevelOpts}
                        </Select>
                        <FormHelperText>{functionLevelTip}</FormHelperText>
                      </FormControl>
                    )}
                    {showChooseDelete && (
                      <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="select-chooseDelete">
                          {showDeletedOptTitle}
                        </InputLabel>
                        <Select
                          name="selectedDeleteChoice"
                          value={selectedDeleteChoice}
                          onChange={this.handleChanged}
                          input={<Input id="select-chooseDelete" />}
                          MenuProps={MenuProps}
                        >
                          {showDeletedOpts}
                        </Select>
                        <FormHelperText>{showDeletedTip}</FormHelperText>
                      </FormControl>
                    )}
                  </GridItem>
                </GridContainer>
                <br />
                {autoReport && (
                  <div>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={5}>
                        <FormControl className={classes.formControl}>
                          <InputLabel htmlFor="select-multiple-checkbox">
                            Days to Send
                          </InputLabel>
                          <Select
                            name="DaysToNotify"
                            multiple={true}
                            value={this.state.selectedDaysToNotify}
                            input={<Input id="select-multiple-checkbox" />}
                            renderValue={this.renderSelectedDayValues}
                            onChange={this.handleDaySelected}
                            MenuProps={MenuProps}
                          >
                            <MenuItem value={"All"}>
                              <Checkbox checked={this.state.allDaysSelected} />
                              <ListItemText primary={"All"} />
                            </MenuItem>
                            {dayMenu}
                          </Select>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={3}>
                        <FormControl className={classes.formControl}>
                          <div className="picker">
                            {/* <InlineTimePicker
                              label="Time to Send"
                              value={this.state.StartHour}
                              onChange={this.handleStartTimeChange}
                              style={{
                                width: "100%"
                              }}
                            /> */}
                            <form className={classes.container} noValidate>
                              <TextField
                                id="time"
                                label="Time to Send"
                                type="time"
                                defaultValue={this.state.StartHour}
                                className={classes.textField}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                inputProps={{
                                  step: 900, // 5 min
                                }}
                                onChange={this.handleStartTimeChange}
                              />
                            </form>
                          </div>
                        </FormControl>
                      </GridItem>
                      <Tooltip title={daysToIncludeToolTip} placement="top">
                        {daysToInclude}
                      </Tooltip>
                    </GridContainer>
                    <br />
                  </div>
                )}
              </CardBody>
              <CardFooter>
                <GridItem xs={12} sm={12} md={6}>
                  <Button
                    color="success"
                    onClick={
                      this.reportOptionButton(0)
                    }
                  >
                    {buttonTitle}
                  </Button>
                {!this.props.autoReport && (
                  <Button
                    color="success"
                    onClick={
                      this.reportOptionButton(1)
                    }
                  >
                    {this.props.tableLoading && this.props.exportOption == 1 ? (
                        <ReactLoading
                          type="bubbles"
                          color="#000000"
                          style={{
                            width: "20%",
                            margin: "auto",
                          }}
                        />
                      ) : "Export Csv"
                    }
                    
                  </Button> 
                )}
                {!this.props.autoReport && (
                  (this.state.selectedLocIds.length <= 1) ? 
                  (
                    <Button
                      color="success"
                      onClick={
                        this.reportOptionButton(2)
                      }
                    >
                    {this.props.tableLoading && this.props.exportOption == 2 ? (
                        <ReactLoading
                          type="bubbles"
                          color="#000000"
                          style={{
                            width: "20%",
                            margin: "auto",
                          }}
                        />
                        ) : "Export Pdf"
                      }
                    </Button> 
                  ) : (
                    <Button
                      color="success"
                      disabled
                    >
                        Export Pdf
                    </Button> 
                  )
                )
                }
                </GridItem>
                {this.props.autoReport &&
                  this.props.edit && (
                      <Button
                        color="transparent"
                        onClick={this.props.handleEditClose}
                      >
                        Cancel
                      </Button>
                  )}
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(styles)(ReportOptions);



// WEBPACK FOOTER //
// ./src/components/ReportOptions/ReportOptions.jsx